module.exports = __webpack_public_path__ + "578d3f51f00e5b71588100fd0fa2ed09.png";